import { ApiErrors } from 'config/ApiConfig';

export type AxiosAuthAction =
  | { type: 'logout'; message: string }
  | { type: 'forbidden'; message: string }
  | { type: 'none' };

/**
 * Decide o tratamento de erros de autenticação/autorização no interceptor Axios.
 * 401 = sessão inválida → logout; 403 = sem permissão no recurso → toast, mantém sessão.
 */
export function resolveAxiosAuthAction(status: number | undefined): AxiosAuthAction {
  if (status === 401) {
    return {
      type: 'logout',
      message: 'Sessão expirada, favor fazer login novamente.',
    };
  }
  if (status === 403) {
    return {
      type: 'forbidden',
      message: ApiErrors.FORBIDDEN,
    };
  }
  return { type: 'none' };
}
